import { prefix } from "../../../core/design-tokens/meta";
import { componentClasses } from "../../../core/components/icon/icon";
import { classes } from "../../../core/js/utilities";

const fontIconTemplate = ({ classes }) => {
    return `<i class="${classes}" aria-hidden="true"></i>`;
};

const svgIconTemplate = ({ name, classes }) => {
    return `
<svg class="${classes}" focusable="false">
    <use xlink:href="#${prefix}icon--${name}"></use>
</svg>`;
};

export const iconTemplate = ({ type, name, additionalClasses = [] }) => {
    const iconClasses = classes({
        [componentClasses.base]: true,
        [`${prefix}icon--${name}`]: type === "font-icon" && Boolean(name),
    })
        .concat(" " + additionalClasses.join(" "))
        .trim();

    return type === "svg"
        ? svgIconTemplate({ name, classes: iconClasses })
        : fontIconTemplate({ classes: iconClasses });
};
